module.exports = __webpack_public_path__ + "img/banner32.5a9d1ae3.png";